// extracted by mini-css-extract-plugin
export default {"edit":"GeneralInfo_edit__dMwSl","cancel":"GeneralInfo_cancel__M6ktk"};